import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Layout from '../App/layout'
import LayoutContentWrapper from '../../components/utility/layoutWrapper'
import ContentLayout from '../../components/utility/layoutContent'
import PaymentVouchersIndexContainer from './PaymentVouchersIndexContainer'

class PaymentVoucherIndexPage extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired
    }

    componentDidMount() {
        document.title = 'Payment Vouchers | OSH CRM'
    }

    render () {
        const { path } = this.props.match

        return (
            <Layout>
                <LayoutContentWrapper breadcrumbs={[
                    { path, name: 'Payment Vouchers' }
                ]}>
                    <ContentLayout>
                        <PaymentVouchersIndexContainer />
                    </ContentLayout>
                </LayoutContentWrapper>
            </Layout>
        )
    }
}

export default PaymentVoucherIndexPage
